import classNames from 'classnames';
import { includes, keys } from 'lodash-es';

import { FAIcon } from '../adapters/fontAwesomeAdapters';
import srcAA from '../../resources/img/airline-logos/AA.png';
import srcAS from '../../resources/img/airline-logos/AS.png';
import srcDL from '../../resources/img/airline-logos/DL.png';
import srcUA from '../../resources/img/airline-logos/UA.png';
import srcHA from '../../resources/img/airline-logos/HA.png';
import srcWN from '../../resources/img/airline-logos/WN.png';
import srcF9 from '../../resources/img/airline-logos/F9.png';
import { useAirlineLogosStyles } from './AirlineLogos.styles';

const logosMap = {
  AA: srcAA,
  AS: srcAS,
  DL: srcDL,
  UA: srcUA,
  HA: srcHA,
  WN: srcWN,
  F9: srcF9,
};
const knownLogos = keys(logosMap);

export const UnknownAirlineLogoIcon = () => {
  const { styles } = useAirlineLogosStyles();
  return (
    <div className={classNames('airline-icon', styles.missingAirlineLogo)}>
      <FAIcon icon="plane" />
    </div>
  );
};

export const UnknownAirlineLogoOrderBadge = ({ index }) => {
  const { styles } = useAirlineLogosStyles();

  return <div className={styles.airlineLogoUnknown}>{index}</div>;
};

export const AirlineLogo = ({ airline, fallback }) => {
  if (includes(knownLogos, airline))
    return (
      <img className="airline-icon" src={logosMap[airline]} alt={airline} />
    );

  return fallback;
};
